import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/NR8YyzE3wRWT8whN9">
              <CFImage src={mobileMap} w="100%" alt="Grand Crystal Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://goo.gl/maps/NR8YyzE3wRWT8whN9">
              <CFImage src={locationMap} w="100%" alt="Grand Crystal Map" />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
